import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground
} from "react-native"

import {verticalScale, moderateScale, scale} from "../../../tools/Scaling";
import HMActionBar from "../../../customviews/HMActionBar";
import i18n from "../../../I18n/i18n";
import * as NavigationService from "../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";

import HMButton from "../../../customviews/HMButton";
import store from "../../../redux/store";
import {typeExport} from "../../../redux/store/type";

export default class LoginScreen extends Component {

    constructor(props) {
        super(props)
        this.state = {
            // mobile: this.props.route.params.mobile
            mobile: "",
            password: ''
        }
    }

    hiddenModal() {
        this.setState({
                visibleModal: ''
            },
            () => {
            })
    }


    async setToken(token) {
        await AsyngStorageClass.setToken(token);

    }

    componentWillReceiveProps(propss) {

        if (propss.results != null) {
            //  this.loadingButton.showLoading(false);

            if (propss.results.status == true) {



            }
            else {
                alert(propss.results.message)

            }
        }

    }

    getData() {
        let {mobile, password} = this.state
        this.props.callService(
            typeExport.urlGetLoginScreen,
            `?mobile=${mobile}&password=${password}&token_fb=${this.props.DataSplashScreen.token_fb}`,
            "TypegetDataLoginScreen",
            "POST"
        );

    }


    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }


    render() {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            props={this.props} statusBarTransparent
                            text={i18n.t('login.title')}

                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                            <HMButton
                                type={"outline"}
                                textType={"bold"}
                                onPress={() =>
                                    NavigationService.navigateParams("LoginEnterPhoneCodeScreen", {})}
                                text={i18n.t('constant.LoginWithCode')}
                                style={{
                                    width: '85%',
                                    height: moderateScale(40),
                                    marginVertical: moderateScale(6),
                                    paddingVertical: moderateScale(25)
                                }}/>
                            <HMButton
                                type={"outline"}
                                textType={"bold"}
                                onPress={() =>
                                    NavigationService.navigateParams("LoginEnterPhoneScreen", {})}
                                text={i18n.t('constant.LoginWithPass')}
                                style={{
                                    width: '85%',
                                    height: moderateScale(40),
                                    marginVertical: moderateScale(6),
                                    paddingVertical: moderateScale(25)
                                }}/>
                           {/* <HMButton
                                type={"outline"}
                                textType={"bold"}
                                onPress={() =>
                                    NavigationService.navigateParams("ShowMap", {})}
                                text={i18n.t('constant.Routing')}
                                style={{
                                    width: '85%',
                                    height: moderateScale(40),
                                    marginVertical: moderateScale(6),
                                    paddingVertical: moderateScale(25)
                                }}/>

                            <HMButton
                                type={"outline"}
                                textType={"bold"}
                                onPress={() =>
                                    NavigationService.navigateParams("MainScreen", {})}
                                text={"صفحه اصلی"}
                                style={{
                                    width: '85%',
                                    height: moderateScale(40),
                                    marginVertical: moderateScale(6),
                                    paddingVertical: moderateScale(25)
                                }}/>*/}

                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }

}
